import React from "react";
import { BannerTable } from "./BannerTable";
import { DeleteModal } from "../../../Common/DeleteModal";

export function Section1({ deviceType, setDeviceType }: any) {
    return (
        <div className="banner-container">
            <section className="text-section">
                <BannerTable
                    deviceType={deviceType}
                    setDeviceType={setDeviceType}
                    section={"Section1"}
                    path={["template", "SiteWeb", "LaindingPage", "Section1"]}
                />

                <DeleteModal section="Section1" />
            </section>
        </div>
    );
}
